async function getAllItems(fileName) {
    const response = await fetch(fileName,
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
    )
    if (response.ok) {
        const data = await response.json();
        return data;
    }
    else {
        return [];
    }
};

async function getRecentItems(fileName, recentItemsCount) {
    const data = await getAllItems(fileName);
    const recentNews = data.length >= recentItemsCount
        ? data.slice(0, recentItemsCount)
        : data;
    return recentNews;
};

export { getAllItems, getRecentItems }